export default __webpack_public_path__ + "static/media/PAYROLL-Enterprise-1.f97c7cbf.png";